// Componente Badge para etiquetas y estados
const badgeVariants = {
  default: 'bg-surface-card text-text-secondary border-border-subtle',
  cyan: 'bg-cyan/10 text-cyan border-cyan/20',
  success: 'bg-success/10 text-success border-success/20',
  warning: 'bg-warning/10 text-warning border-warning/20',
  error: 'bg-error/10 text-error border-error/20',
  navy: 'bg-navy text-cyan border-navy-light',
}

const badgeSizes = {
  sm: 'px-2 py-0.5 text-[0.625rem]',
  md: 'px-2.5 py-1 text-xs',
  lg: 'px-3 py-1.5 text-sm',
}

export default function Badge({
  children,
  variant = 'default',
  size = 'md',
  dot = false,
  icon: Icon,
  className = '',
}) {
  return (
    <span
      className={`
        inline-flex items-center gap-1.5 font-medium font-body
        rounded-full border whitespace-nowrap
        ${badgeVariants[variant]}
        ${badgeSizes[size]}
        ${className}
      `}
    >
      {dot && (
        <span className={`w-1.5 h-1.5 rounded-full ${
          variant === 'success' ? 'bg-success' :
          variant === 'error' ? 'bg-error' :
          variant === 'warning' ? 'bg-warning' :
          variant === 'cyan' ? 'bg-cyan' :
          'bg-text-muted'
        }`} />
      )}
      {Icon && <Icon className="w-3 h-3" />}
      {children}
    </span>
  )
}
